import interceptor from '@/plugins/interceptor';
const pathController = '/primera-entrevista'

export default {
    state: () => ({
      redirectTo: null,
    }),
    getters: {
      getRedirectPath: state => state.redirectTo,
    },
    mutations: { 
      redirectAfterLogin(state,path){
        state.redirectTo = path;
      }
    },
    actions: {
      async security_authenticate(_, model) {
        return await interceptor.anonymous.post(`${process.env.VUE_APP_API_URL}${pathController}/authenticate`, model);
      },
      async security_beginPasswordRecovery(_, model) {
        return await interceptor.anonymous.post(`${process.env.VUE_APP_API_URL}${pathController}/recover-password`, model);
      },
      async security_endPasswordRecovery(_, model) {
        return await interceptor.anonymous.post(`${process.env.VUE_APP_API_URL}${pathController}/endPasswordRecovery`, model);
      },
      async security_resendRecoveryMail(_, model) {
        return await interceptor.anonymous.post(`${process.env.VUE_APP_API_URL}${pathController}/resendRecoveryMail`, model);
      },
      async security_refreshToken(_, model) {
        return await interceptor.anonymous.post(`${process.env.VUE_APP_API_URL}${pathController}/refreshToken`, model);   
      },
      async security_pickRole(_, model) {
        return await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/pickRoll`, model);   
      }
    }
  }